import React from 'react';
import Product from './Product';

export default function ProductList(props) {
  const { productList } = props;

  return (
    <div>
      {productList.length > 0 && (
        <div className='row mt-2'>
          <div className='col-3 m-auto'>
            <h4>Product</h4>
          </div>
          <div className='col-3 m-auto'>
            <h4>Quantity</h4>
          </div>
          <div className='col-3 m-auto'>
            <h4>Amount</h4>
          </div>
          <div className='col-3 m-auto'>
            <h4>Remove</h4>
          </div>
        </div>
      )}

      {productList.map((product, index) => (
        <Product
          key={index}
          productList={product}
          index={index}
          decrementQuantity={props.decrementQuantity}
          incrementQuantity={props.incrementQuantity}
          removeItem={props.removeItem}
        />
      ))}
    </div>
  );
}
